import React from 'react';
import { TIPO_LABELS } from '../data/orientaciones';

export default function Alertas({ casos, onVerDetalle }) {
  const hoy = new Date();
  const vencidas = casos.filter(c => {
    if (c.estado === 'Cerrado' || !c.fechaAlerta) return false;
    return Math.ceil((new Date(c.fechaAlerta) - hoy) / (1000*60*60*24)) < 0;
  });
  const proximas = casos.filter(c => {
    if (c.estado === 'Cerrado' || !c.fechaAlerta) return false;
    const d = Math.ceil((new Date(c.fechaAlerta) - hoy) / (1000*60*60*24));
    return d >= 0 && d <= 7;
  });
  const sinDest = casos.filter(c => !c.destinatario && c.estado !== 'Cerrado');

  const CasoRow = ({ c, tipo }) => {
    const dias = c.fechaAlerta ? Math.ceil((new Date(c.fechaAlerta) - hoy) / (1000*60*60*24)) : null;
    return (
      <div onClick={() => onVerDetalle(c.id)} style={{ display:'flex', alignItems:'flex-start', gap:12, padding:'12px 16px', borderBottom:'1px solid var(--gray-100)', cursor:'pointer' }}
        onMouseEnter={e => e.currentTarget.style.background='rgba(0,45,98,.03)'}
        onMouseLeave={e => e.currentTarget.style.background='transparent'}>
        <div style={{ minWidth:8, height:8, borderRadius:'50%', background: tipo==='urgente'?'var(--minerd-red)':tipo==='proximo'?'var(--gold)':'var(--minerd-blue)', marginTop:5, flexShrink:0 }} />
        <div style={{ flex:1 }}>
          <div style={{ fontSize:13, fontWeight:700, color:'var(--gray-900)' }}>{c.centro}</div>
          <div style={{ fontSize:12, color:'var(--gray-500)', marginTop:2 }}>
            {TIPO_LABELS[c.tipo]||c.tipo}
            {dias !== null && ` · ${dias < 0 ? `Vencida hace ${Math.abs(dias)} día(s)` : `Vence en ${dias} día(s)`}`}
          </div>
          {c.destinatario && <div style={{ fontSize:11, color:'var(--minerd-green)', marginTop:3 }}>→ {c.destinatario}</div>}
        </div>
        <span style={{ fontSize:11, color:'var(--gray-400)', whiteSpace:'nowrap' }}>{c.fecha}</span>
      </div>
    );
  };

  return (
    <div>
      {vencidas.length > 0 && (
        <div className="card" style={{ marginBottom:14 }}>
          <div className="card-header" style={{ background:'linear-gradient(90deg,rgba(206,17,38,.06),transparent)' }}>
            <h3 style={{ color:'var(--minerd-red)' }}>Fechas vencidas ({vencidas.length})</h3>
          </div>
          {vencidas.map(c => <CasoRow key={c.id} c={c} tipo="urgente" />)}
        </div>
      )}
      {proximas.length > 0 && (
        <div className="card" style={{ marginBottom:14 }}>
          <div className="card-header" style={{ background:'linear-gradient(90deg,rgba(245,166,35,.06),transparent)' }}>
            <h3 style={{ color:'#b45309' }}>Próximos a vencer ({proximas.length})</h3>
          </div>
          {proximas.map(c => <CasoRow key={c.id} c={c} tipo="proximo" />)}
        </div>
      )}
      {sinDest.length > 0 && (
        <div className="card" style={{ marginBottom:14 }}>
          <div className="card-header" style={{ background:'linear-gradient(90deg,rgba(0,45,98,.04),transparent)' }}>
            <h3 style={{ color:'var(--minerd-blue)' }}>Sin destinatario ({sinDest.length})</h3>
          </div>
          {sinDest.map(c => <CasoRow key={c.id} c={c} tipo="info" />)}
        </div>
      )}
      {vencidas.length === 0 && proximas.length === 0 && sinDest.length === 0 && (
        <div className="card">
          <div style={{ padding:40, textAlign:'center', color:'var(--gray-400)', fontSize:14 }}>
            <div style={{ fontSize:32, marginBottom:12 }}>✓</div>
            No hay alertas activas. ¡Todo al día!
          </div>
        </div>
      )}
    </div>
  );
}
